<template>
  <div id="app" v-if="loadedAuth">
    <script type="application/javascript" crossorigin="anonymous" :src="'https://connect.facebook.net/pt_PT/sdk.js#xfbml=1&version=v7.0&appId=' + getFacebookAppId() + '&autoLogAppEvents=1'" nonce="EcBscZrf"></script>
    <menuComp v-if="!routeWithoutMenu()" />
    <router-view/>
    <footerComp v-if="!routeWithoutFooter()" />
    <cookies @close="cookiesAccepted = true" v-if="!cookiesAccepted" />
    <div class="return-top" @click="scrollTop()">
      <img src="@/assets/arrow-filled.svg">
    </div>
  </div>
</template>
<script>
import menuComp from '@/components/menu.vue'
import footerComp from '@/components/footer.vue'
import cookies from '@/components/cookies.vue'
export default {
  components: {
    footerComp,
    menuComp,
    cookies
  },
  data() {
    return {
      loadedAuth: false,
      cookiesAccepted: localStorage.getItem('accept-cookies')
    }
  },
  async mounted () {
    await this.$store.dispatch('loadUserData')
    window.addEventListener('scroll', this.scrollEvent)
    this.loadedAuth = true
    try {
      let ginterval = setInterval(() => {
        if (gapi) {
          clearInterval(ginterval)
          gapi.load('auth2', function() {
            window.auth2 = gapi.auth2.init({
              client_id: process.env.VUE_APP_GOOGLE_CLIENT_ID,
              scope: "profile email"
            })
          })
          console.log('Google init with ID:' + process.env.VUE_APP_GOOGLE_CLIENT_ID)
        }
      }, 200)
    } catch (e) {
      console.log(e)
      return e
    }
    let interval = setInterval(() => {
      if (window.FB) {
        clearInterval(interval)
        window.FB.init({
          appId      : process.env.VUE_APP_FACEBOOK_APP_ID,
          status     : true,
          xfbml      : true,
          version    : 'v7.0' // or v2.6, v2.5, v2.4, v2.3
        })
        console.log('Facebook init with ID:' + process.env.VUE_APP_FACEBOOK_APP_ID)
      }
    }, 200)
  },
  destroyed () {
    window.removeEventListener('scroll', this.scrollEvent)
  },
  methods: {
    routeWithoutFooter () {
      return ['admin', 'user'].includes(this.$route.matched[0].name)
    },
    routeWithoutMenu () {
      return ['admin', 'user', 'ponto_de_interesse', 'percurso', 'evento'].includes(this.$route.matched[0].name)
    },
    getFacebookAppId () {
      return process.env.VUE_APP_FACEBOOK_APP_ID
    },
    scrollEvent (e) {
      if (document.body.scrollHeight - window.pageYOffset < 2 * window.innerHeight && window.pageYOffset > 170) {
        this.$el.querySelector('.return-top').style.display = 'block'
      } else {
        this.$el.querySelector('.return-top').style.display = 'none'
      }
    },
    scrollTop () {
      window.scrollTo({left: 0, top: 0, behavior: 'smooth'})
    }
  }
}
</script>
<style lang="scss">
#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #000000;
  font-family: 'Barlow Condensed', sans-serif;
  font-family: 'Sen', sans-serif;
  position: relative;
}

#nav {
  padding: 30px;

  a {
    font-weight: bold;
    color: #000000;
  }
}
a {
  text-decoration: none;
  color: black;
}
.fade-in:not(svg) {
  transform: translateY(50px);
  opacity: 0;
  transition: 1s all;
}
.faded:not(svg) {
  transform: translateY(0px);
  opacity: 1;
}
.zoomable-image {
  display: inline-block;
  overflow: hidden;
  img {
    vertical-align: middle;
    transition: all 10s ease;
    &:hover {
      transform: scale(1.2)
    }
  }
}
input {
  margin-top: 16px;
  padding: 12px 16px;
  font-family: Sen;
  font-size: 16px;
  font-weight: bold;
  color: #d39e27;
  border: solid 1px #f6ede0;
  outline: #d39e27;
  &::placeholder {
    color: rgba(211, 158, 39, 0.5);
  }
  &.error {
    border: solid 1px #ff4040;
  }
}
.return-top {
  position: fixed;
  right: 50px;
  bottom: 50px;
  z-index: 20;
  transform: rotateZ(-90deg);
  cursor: pointer;
  display: none;

  @media screen and (max-width: 900px){
    right: 20px;
    bottom: 20px;
  }

  @media screen and (max-width: 550px){
    right: 8px;
    bottom: 8px;
  }
}
.unselectable {
  -moz-user-select: -moz-none;
  -khtml-user-select: none;
  -webkit-user-select: none;
  -o-user-select: none;
  user-select: none;
}
</style>
